export const CartModuleConsts = {
    CART_PAGE_TITLE: 'World of Sweets - My Cart',
    ORDER_CONFIRMATION_PAGE_TITLE: 'World of Sweets - My Cart',
    PAYMENT_PAGE_TITLE: 'World of Sweets - Cart Payment',
    ORDER_SUMMARY:'World of Sweets - Order Summary',
    REMOVEPOPUPMESSAGE:'Are you sure you want to remove product from cart?',
    BI_TRACKING_IDENTIFIER_TOREMOVE: 3,
    BI_TRACKING_IDENTIFIER_TOPLACEORDER: 4,
    PREPROD: 'preprod',
    ONHOLD_MESSAGE:'You can build your basket, but checkout is disabled. Please contact your depot to remove the hold and start ordering again',
    ONHOLD_MESSAGE_WITH_DEPOT:'You can build your basket, but checkout is disabled. Please contact your depot on ',
    TOKENIZATION_FAILED:'Card verification tokenization failed.',
    FAILED_PLACE_ORDER:'Failed to place order in Magento.',
    FORM_NOT_READY:'Payment form inputs are not fully ready.',
    FAILED_PAYMENT_INTERFACE:'Failed to parse secure payment interface panels.',
    CHECKOUT_NOT_AVAILABLE:'The checkout form fields are temporarily unavailable.',
    PAYMENT_DECLINED:'Payment has been declined.'
}